var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nba-primary-content", class: _vm.bemFacets },
    [
      _c("div", {
        staticClass: "nba-primary-content--background",
        style: _vm._f("bgImage")(_vm.productImage)
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nba-primary-content--content-wrapper" }, [
        _c(
          "div",
          { staticClass: "nba-primary-content--title-wrapper" },
          [_vm._t("title")],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nba-primary-content--statement" },
          [_vm._t("content")],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nba-primary-content--link-list" },
          [_vm._t("links")],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nba-primary-content--content-image" },
        [_vm._t("image")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc4898ce", { render: render, staticRenderFns: staticRenderFns })
  }
}